/** * * Asynchronously loads the component for
ApiManager
* */ import { lazyLoad } from 'utils/loadable';
export const ApiManager = lazyLoad(() => import('./index'));
